import React, { PureComponent } from 'react';
import EditWrapper from '../EditWrapper/EditWrapper';
import { ParallaxBanner } from 'react-scroll-parallax';
import { withStyles } from '@material-ui/core/styles';
import "./Banner.css";
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { base_url } from '../../data/db';
import logo from '../../images/logo.png';

const styles = theme => ({
  bannerHeight: {
    height: '300px',
    [theme.breakpoints.down('md')]: {
      height: '100px !important',
    },
  },
  titlePosition: {
    position: 'absolute',
    // top: '50%',
    // transform: 'translateY(-50%)',
    zIndex: 2,
    padding: '0 20px',
    height: '100%'
  },
  logo: {
    width: '200px',
    marginRight: '20px',
    verticalAlign: 'middle',
    whiteSpace: 'normal',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  title: {
    display: 'inline-block',
    verticalAlign: 'middle',
    textShadow: '2px 3px 3px rgba(40,40,40)',
    [theme.breakpoints.down('md')]: {
      fontSize: '2rem',
    },
  },
  gradientBG: {
    position: 'absolute',
    top: '0px',
    left: '0',
    right: '-190px',
    bottom: '0',
    zIndex: -1,
    background: 'linear-gradient(to right, rgba(0, 0, 0, 0.628) 0%, rgba(0, 0, 0, 0.378) 19%, rgba(0, 0, 0, 0.2502) 34%, rgba(0, 0, 0, 0.2224) 47%, rgba(0, 0, 0, 0.1946) 56.5%, rgba(0, 0, 0, 0.1668) 65%, rgba(0, 0, 0, 0.139) 73%, rgba(0, 0, 0, 0.1112) 80.2%, rgba(0, 0, 0, 0.0834) 86.1%, rgba(0, 0, 0, 0.0556) 91%, rgba(0, 0, 0, 0.02776) 95.2%, rgba(0, 0, 0, 0.002) 98.2%, transparent 100%)'
  },
  alignMiddle: {
    display: 'inline-block',
    verticalAlign: 'middle',
    height: '100%'
  }
});

class Banner extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            banner_image: this.props.src ? `"${base_url}${this.props.src}"` : false
        }
    }
  render() {
    const { classes } = this.props;
      const image = this.props.src ? `"${base_url}${this.props.src}"` : false;
      const image_hover = this.props.src_hover ? `"${base_url}${this.props.src_hover}"` : image;
    return (
      <EditWrapper onCopy={this.props.editMode.onCopy} editEnabled={this.props.editMode.editEnabled} removeEnabled={this.props.editMode.removeEnabled} onRemove={this.props.handleRemove} onEdit={() => this.props.showEdit(0)} editTooltip="Edit List">
        <div className="banner-component" style={{ ...this.props.style }}>
                <div className="default-shadow" onMouseOver={e => this.setState({ banner_image: image_hover })} onMouseOut={e => this.setState({ banner_image: image })}>
            <ParallaxBanner
              className={classes.bannerHeight}
              layers={[
                {
                  image: this.state.banner_image,
                  amount: 0.4
                }
              ]}
              style={
                { height: this.props.height ? this.props.height : '150px' }
              }
            >
              <div className={classes.titlePosition}>
                <div className={classes.gradientBG}></div>
                <div className={classes.alignMiddle}></div>
                {this.props.logo_ind && (
                  <img alt="MDOT Logo" src={logo} className={classes.logo} />
                )}
                {this.props.title_ind ? null : <Typography className={`${this.props.textColor} ${classes.title}`} variant="h3">{this.props.title}</Typography>}
              </div>
            </ParallaxBanner>
          </div>
        </div>
      </EditWrapper>
    )
  }
}
Banner.propTypes = {
  classes: PropTypes.object.isRequired
};
Banner.defaultProps = {
  handleEdit: () => { },
  handleRemove: () => { },
  style: {},
  src: "",
  title: "",
  textColor: "black-text",
  editMode: { editEnabled: false, removeEnabled: false }
}
export default (withStyles(styles)(Banner));